import * as c from './types';

import createReducer from '../../reducers/utils/createReducer';

const initialState = {
  data: [],
  sensorData: {},
  machineStops: [],
  stopCauses: [],
  machineGroups: [],
  isLoading: false,
  error: null,
  isMachineLoading: false,
  isMachineGroupsLoading: false
};

export default createReducer(initialState, {
  [c.GET_MACHINE_SENSORS_DETAILS_REQUEST]: (state) => ({
    ...state,
    error: null
  }),
  [c.GET_MACHINE_SENSORS_DETAILS_SUCCESS]: (state, { payload }) => ({
    ...state,
    sensorData: payload
  }),
  [c.GET_MACHINE_SENSORS_DETAILS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),

  [c.GET_MACHINE_DETAILS_REQUEST]: (state) => ({
    ...state,
    error: null
  }),
  [c.GET_MACHINE_DETAILS_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload
  }),
  [c.GET_MACHINE_DETAILS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),
  [c.GET_MACHINE_STOPS_REQUEST]: (state) => ({
    ...state,
    error: null,
    machineStops: [],
    isLoading: true
  }),
  [c.GET_MACHINE_STOPS_SUCCESS]: (state, { payload }) => ({
    ...state,
    machineStops: payload,
    isLoading: false
  }),
  [c.GET_MACHINE_STOPS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.GET_MACHINE_STOP_CAUSES_REQUEST]: (state) => ({
    ...state,
    error: null
  }),
  [c.GET_MACHINE_STOP_CAUSES_SUCCESS]: (state, { payload }) => ({
    ...state,
    stopCauses: payload
  }),
  [c.GET_MACHINE_STOP_CAUSES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),

  [c.PUT_MACHINE_STOPS_REQUEST]: (state) => ({
    ...state,
    error: null
  }),
  [c.PUT_MACHINE_STOPS_SUCCESS]: (state) => ({
    ...state
  }),
  [c.PUT_MACHINE_STOPS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),

  [c.GET_MACHINE_GROUPS_REQUEST]: (state) => ({
    ...state,
    isMachineGroupsLoading: true,
    error: null
  }),
  [c.GET_MACHINE_GROUPS_SUCCESS]: (state, { payload }) => ({
    ...state,
    isMachineGroupsLoading: false,
    machineGroups: payload
  }),
  [c.GET_MACHINE_GROUPS_ERROR]: (state, { payload }) => ({
    ...state,
    isMachineGroupsLoading: false,
    error: payload
  }),

  [c.GET_STOPS_MACHINE_GROUPS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isMachineLoading: true
  }),
  [c.GET_STOPS_MACHINE_GROUPS_SUCCESS]: (state, { payload }) => ({
    ...state,
    stopMachineGroups: payload,
    isMachineLoading: false
  }),
  [c.GET_STOPS_MACHINE_GROUPS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isMachineLoading: false
  })
});
